import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiHeaderFilterMenuComponent } from './ui-header-filter-menu.component';
import { UiTagSidebarModule } from '@ui/modules/ui-tag-sidebar/ui-tag-sidebar.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [UiHeaderFilterMenuComponent],
  imports: [
    CommonModule,
    RouterModule,
    UiTagSidebarModule,
  ],
})
export class UiHeaderFilterMenuModule { }
